import React, { useEffect, useState } from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { CertifiesCardVM } from '../../Structure/ViewModels/Trainee/CertifiesCardVM'
import { CourseCertify } from '../../Structure/Models/Course'

const CertifiesCard = (props:{data:CourseCertify , id:string , name:string}) => {
    const [vm , setVm] = useState<{viewModel:CertifiesCardVM}>({viewModel: new CertifiesCardVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.setData(props.data)
    },[])

  return (

    <Row className='py-3'>
        <h5 className='py-3'>{control.Data?.specialization}</h5>
        <Accordion defaultActiveKey="0" className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
            {
                control.Data?.levels.map((item,index)=>(
                    <Accordion.Item  key={index} eventKey={(index+1).toString()} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                        <Accordion.Header className=' rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                            <h5 className='px-3'>
                                {item.level}
                            </h5>
                        </Accordion.Header>
                        <Accordion.Body >
                            {
                                item.certified_path?(
                            <Row className='py-3 justify-content-around text-center bg-success text-white'  >
                                <Col md={3} className='py-1'>
                                    {item.certified_path?.specialization ||''}
                                </Col>
                                <Col md={3} className='py-1'>
                                    
                                    &nbsp;  من  &nbsp;
                                    {item.certified_path?.start}
                                </Col>
                                <Col  md={3} className='py-1'>
                                    &nbsp;  الى &nbsp;
                                    {item.certified_path?.end}
                                </Col>
                                <Col  md={3} className='py-1'>
                                    {item.certified_path?.hours} ساعة
                                    
                                </Col>
 
                                {/* <Col md={1}>
                                    <div className='material-symbols-outlined text-white'>
                                        print
                                    </div>
                                </Col> */}
                            </Row>
                            ):(null)
                            }
                            {
                                item.certifies?.map((it,ind)=>(
                                    <Row  key={index} className='py-3 justify-content-around text-center' style={{background:ind%2?'white':'rgba(200,200,200,0.2)'}} >
                                        <Col md={3}>
                                            {it.course}
                                        </Col>
                                        <Col md={3} className='py-1'>
                                            
                                            &nbsp;  من  &nbsp;
                                            {it.start}
                                        </Col>
                                        <Col md={3} className='py-1'>
                                            &nbsp;  الى &nbsp;
                                            {it.end}
                                        </Col>
                                        <Col md={3} className='py-1'>
                                                {it.hours} ساعة
                                            
                                        </Col>
                                        {/* <Col md={1}>
                                            <div className='material-symbols-outlined text-success'>
                                                print
                                            </div>
                                        </Col> */}
                                    </Row>
                                ))
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                ))
            }
        </Accordion>
    </Row>

  )
}

export default CertifiesCard
